import React, { Component } from "react";
import { withTranslation } from "react-i18next"; 
import { Container, Navbar } from "reactstrap";
import EmergencyServicesLoginMenu from "./EmergencyServicesLoginMenu"; 
import "../NavMenu/NavMenu.css";

class EmergencyServicesNavMenu extends Component {

    constructor(props) {
        super(props);

        this.toggleNavbar = this.toggleNavbar.bind(this);
        
        this.state = {
            collapsed: true,
            userIsAuthenticated: false
        };
    }

    async componentDidMount() {
        try {
            // Call server to see if user is authenticated
            const res = await fetch("/Account/whoami", { credentials: "include" });
            if (res.ok) {
                const data = await res.json();
                this.setState({ userIsAuthenticated: data.isAuthenticated });
            } else {
                this.setState({ userIsAuthenticated: false });
            }
        } catch (err) {
            console.error("Error checking user authentication:", err);
            this.setState({ userIsAuthenticated: false });
        }
    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }

    doLogin() {
        // Redirect to MVC login page
        window.location.href = "/Account/Login";
    }

    doLogout() {
        // Call logout endpoint on server
        fetch("/Account/Logout", { method: "POST", credentials: "include" })
            .then(() => window.location.href = "/") // redirect after logout
            .catch(err => console.error("Logout failed:", err));
    }

    render() {
        const t = this.props.t;
        
        return (
            <header className="ShipsRadioHeader">  
                <Navbar className="navbar-expand-md border-bottom box-shadow mb-3" dark style={{ backgroundColor: "#004D44"}}>
                    <Container>
                        <div className="HarpImage mx-1" > </div>
                        <EmergencyServicesLoginMenu userIsAuthenticated={this.state.userIsAuthenticated} t={t} />
                    </Container>  
                </Navbar>  
            </header >
        );
    }
}

const languageAwareComponent = withTranslation()(EmergencyServicesNavMenu);
export default languageAwareComponent;